<template>
    <div>
        <b-container fluid>
            <div class="my-3">
                <div v-for="question in questions">
                    <div v-if="question.type == 'fill_in_the_blank' || question.type == 'new_fill_in_the_blank'">
                        <div>Question Type: Fill In The Blank / Inline Choice</div>
                        <div> Question:
                            <div class="fib-question-container" v-html="formatFibQuestion(question.content.question)">
                            </div>
                        </div>
                        <div>
                            <div v-for="blank in question.content.blanks">
                                <div>Blank {{ blank.blank_id }} Options: </div>
                                <div v-for="option in blank.options">
                                    <div v-html="option.option"></div>
                                </div>
                                <div> Blank {{ blank.blank_id }} Answer: <span v-html='blank.answer'></span></div>
                            </div>
                        </div>
                    </div>

                    <div v-if="question.type == 'labeling'">
                        <div>Question Type: Labeling</div>
                        <Labeling
                            :question="question"
                            :question_html="question.content.question"
                        />
                    </div>

                    <div v-if="question.type == 'matching'">
                        <div>Question Type: Matching</div>
                        <Matching
                            :question="question"
                            :question_html="question.content.question_prompt"
                        />
                    </div>

                    <div v-if="
                        question.type == 'multiple_choice' ||
                        question.type == 'article_assessment' ||
                        question.type == 'new_multiple_choice'
                    ">
                        <div>Question Type: Multiple Choice</div>
                        <multiple-choice
                            :question="question"
                            :question_html="question.content.question"
                        />
                    </div>

                    <div v-if="question.type == 'open_response'">
                        <div>Question Type: Open Response</div>
                        <open-response
                            :question="question"
                            :question_html="question.content.question"
                        />
                    </div>

                    <div v-if="question.type == 'drawing'">
                        <div>Question Type: Drawing</div>
                        <Drawing
                            :question="question"
                            :question_html="question.content.question"
                        />
                    </div>

                    <div v-if="question.type == 'select_all_that_apply' || question.type == 'new_select_all_that_apply'">
                        <div>Question Type: Check All That Apply / Multiselect</div>
                        <select-all-that-apply
                            :question="question"
                            :question_html="question.content.question"
                        />
                    </div>

                    <div v-if="question.type == 'sorting'">
                        <div>Question Type: Sorting</div>
                        <Sorting
                            :question="question"
                            :question_html="question.content.question"
                        />
                    </div>

                    <div v-if="question.type == 'think_and_review'">
                        <div>Question Type: Think And Review</div>
                        <true-false
                            :question="question"
                            :question_html="question.content.question"
                        />
                    </div>

                    <div v-if="question.type == 'true_false'">
                        <div>Question Type: True or False</div>
                        <true-false
                            :question="question"
                            :question_html="question.content.question"
                        />
                    </div>

                    <div v-if="question.type == 'grouping'">
                        <div>Question Type: Grouping</div>
                        <grouping
                            :question="question"
                            :question_html="question.content.question"
                        />
                    </div>

                    <div v-if="question.type == 'numeric_response'">
                        <div>Question Type: Numeric Response</div>
                        <numeric-response
                            :question="question"
                            :question_html="question.content.question"
                        />
                    </div>
                    <hr/>
                </div>
            </div>
        </b-container>
    </div>
</template>

<style lang="scss" >
    .fib-question-container img{
        max-width: 250px;
    }
</style>

<script>
    import FillInTheBlank from '@/components/questions/FillInTheBlank'
    import Labeling from '@/components/questions/Labeling'
    import Matching from '@/components/questions/Matching'
    import MultipleChoice from '@/components/questions/MultipleChoice'
    import OpenResponse from '@/components/questions/OpenResponse'
    import SelectAllThatApply from '@/components/questions/SelectAllThatApply'
    import Sorting from '@/components/questions/Sorting'
    import TrueFalse from '@/components/questions/TrueFalse'
    import Grouping from '@/components/questions/Grouping'
    import NumericResponse from '@/components/questions/NumericResponse'
    import Drawing from '@/components/questions/Drawing'


export default {
    data: () => ({
        questions: [],
        question_type: '',
        unit_groups_id: null,
        unit_id: null,
        article_id: null,
        assessment_type: ','

    }),
    props: [

    ],
    components: {
        FillInTheBlank,
        Labeling,
        Matching,
        MultipleChoice,
        OpenResponse,
        SelectAllThatApply,
        Sorting,
        TrueFalse,
        Grouping,
        NumericResponse,
        Drawing
    },
    computed: {

    },
    watch: {

    },
    methods: {
        getUnitGroupQuestions () {
            return new Promise((resolve, reject) => {
                this.axios.get('/api/unit_groups/questions/' + this.unit_group_id)
                .then(response => {
                    let questions = []
                    if (response.data) {
                        questions = response.data
                        console.log(response.data);
                        questions = _.orderBy(questions, 'order_number')
                    }
                    console.log('questions 1', questions);
                    this.questions = questions

                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        getUnitQuestions(){
                return new Promise((resolve, reject) => {
                    this.axios.get('/api/units/questions/' + this.unit_id)
                    .then(response => {
                        let questions = []
                        if (response.data) {
                            console.log(response.data);
                            questions = response.data
                            questions = _.orderBy(questions, 'order_number')
                        }
                        this.questions = questions

                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
                })
        },
        getArticleQuestions(){
                return new Promise((resolve, reject) => {
                    this.axios.get('/api/articles/' + this.article_id)
                    .then(response => {
                        let questions = []
                        if (response.data[0].questions) {
                            console.log(response.data);
                            questions = response.data[0].questions;
                            questions = _.orderBy(questions, 'order_number')
                        }
                        this.questions = questions

                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
                })
        },
        formatFibQuestion(question_text) {
            //let question = this.question.content.question
            question_text = question_text.replaceAll('<merlin-img', '<img')
            question_text = question_text.replaceAll('</merlin-img', '</img')
            question_text = question_text.replaceAll('<blank blank_id=\"1\" class=\"blank\"></blank>', ' _____ ')
            return question_text
        },

    },
    mounted () {
        this.question_type = this.$route.params.question_type;
        if(this.question_type == 'unit_group'){
            this.assessment_type = "Thematic Unit Assessment";
            this.unit_group_id = this.$route.params.id;
            this.getUnitGroupQuestions();
        }
        else if(this.question_type == 'unit'){
            this.assessment_type = "Weekly Assessment";
            this.unit_id = this.$route.params.id;
            this.getUnitQuestions();
        }
        else{
            this.assessment_type = "Article";
            this.article_id = this.$route.params.id;
            this.getArticleQuestions();
        }
    }
}
</script>
